export default __webpack_public_path__ + "static/media/264.98874c84.jpg";